<template>
  <div class="audit-node">
    <el-tabs class="m-t-16" v-model="activeTab" auditNodeManage @tab-click="changeTab">
      <el-tab-pane label="专题讲座" name="0">
        <audit-node-list :type="1" />
      </el-tab-pane>
      <el-tab-pane label="理论中心组学习" name="1" lazy>
        <audit-node-list :type="2"/>
      </el-tab-pane>
      <!-- 其他集中培训 -->
      <el-tab-pane label="其他集中培训" name="2" lazy>
        <audit-node-list :type="3"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import AuditNodeList from './components/auditNodeList/index.vue'
export default {
  name: "auditNodeManage",
  components: {AuditNodeList},
  data() {
    return {
      activeTab: 0,
    };
  },
  created() {},
  activated() {},
  computed: {},
  methods: {
    changeTab(e) {

    },
  },
};
</script>
<style lang='scss' scoped>
.audit-node {
  padding: 24px;
}
</style>